import dayjs from 'dayjs';
import { tKey } from 'ember-intl';
import { DATE_AGGREGATION } from 'lumen/utils/constants/general-constants';
import {
  DEFAULT_DAYS_SHOWN_IN_OD,
  OD_DEFAULT_DATE_FORMAT,
} from 'lumen/utils/constants/overview-dashboard-constants';

export function tickPositioner(dataMin, dataMax, isDailyAggregation) {
  const positions = [];

  if (dataMax !== null && dataMin !== null) {
    const startMoment = dayjs.unix(dataMin / 1000);
    const endMoment = dayjs.unix(dataMax / 1000);
    const weeks = endMoment.diff(startMoment, 'week');

    let increment = null;

    if (isDailyAggregation) {
      increment = startMoment.add(1, 'week').unix() * 1000 - dataMin;
    }

    // Based a bit on the MI overview custom tickpositioner
    if (!isDailyAggregation) {
      if (weeks > 50) {
        increment = startMoment.add(8, 'week').unix() * 1000 - dataMin;
      } else if (weeks > 25) {
        increment = startMoment.add(6, 'week').unix() * 1000 - dataMin;
      } else if (weeks > 10) {
        increment = startMoment.add(4, 'week').unix() * 1000 - dataMin;
      } else if (weeks > 6) {
        increment = startMoment.add(3, 'week').unix() * 1000 - dataMin;
      } else if (weeks > 3) {
        increment = startMoment.add(2, 'week').unix() * 1000 - dataMin;
      } else {
        increment = startMoment.add(1, 'week').unix() * 1000 - dataMin;
      }
    }

    for (
      let tick = Math.floor(dataMin);
      tick - increment < dataMax;
      tick += increment
    ) {
      positions.push(tick);
    }
  }

  return positions;
}

export function xAxisLabelFormatter(xValue, isDailyAggregation, intl) {
  const date = dayjs.utc(xValue);

  if (isDailyAggregation) {
    return date.format(OD_DEFAULT_DATE_FORMAT);
  }

  return intl
    .t(tKey('general.week_of'), { date: date.format(OD_DEFAULT_DATE_FORMAT) })
    .toString();
}

export function getDateAggregation(rangeStart, rangeEnd) {
  let dateAggregation = DATE_AGGREGATION.DAY;

  if (
    dayjs(rangeEnd).diff(dayjs(rangeStart), 'day') > DEFAULT_DAYS_SHOWN_IN_OD
  ) {
    dateAggregation = DATE_AGGREGATION.WEEK;
  }

  return dateAggregation;
}
